import React from 'react';
import classNames from 'classnames/bind';
import styles from './AirPod.scss';

const cx = classNames.bind(styles);

const AirPod = ({ initModal }) => {
  return (
    <div className={cx('AirPod')}>
      <div className="detail-wrap-box">
        <div className="close" onClick={initModal}></div>
        {/* <div className="detail-title">
          <h2>에어팟 프로 상세 스펙</h2>
        </div> */}

        <div className="detail-img"></div>

        {/* <div className="datail-contents">
          <div className="detail-subtitle">
            <h3>제품 정보</h3>
          </div>
          <div className="detail-text">
            <ul className="detail-text-list">
              <li className="list">
                <span className="title">제품명</span>
                <span>AidPodsPro</span>
              </li>
              <li className="list pb-21">
                <span className="title">제품 구성</span>
                <span>
                  AirPods Pro, 무선 충전 케이스,
                  <br />
                  실리콘 이어 팁(3가지 크기),
                </span>
              </li>
              <li className="list">
                <span className="title">크기 및 무게</span>
                <span>
                  본품 30.9mm X 21.8mm X 24.0mm, 무게 5.4g
                  <br />
                  케이스 45.2mm X 60.6mm X 2.7mm, 무게 45.6g
                </span>
              </li>
              <li className="list">
                <span className="title">충전 케이스</span>
                <span>Qi 인증 충전기 또는 Lightning 커넥터와 호환</span>
              </li>
              <li className="list">
                <span className="title">배터리</span>
                <span>
                  Airpods Pro 본품
                  <br />
                  한 번 충전으로 음악 감상 시간 최대 4.5시간
                  <br />
                  Airpods Pro와 무선 충전 케이스
                  <br />
                  음악 감상 시간 24시간 이상,
                  <br />
                  통화 시간 18시간 이상
                  <br />
                  케이스에서 5분 충전 시 음악 감상 약 1시간,
                  <br />
                  또는 통화시간 약 1시간
                </span>
              </li>
            </ul>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default AirPod;
